import { Controller } from "@hotwired/stimulus"
import { Modal } from "../utils/modal"
import { visit } from "@hotwired/turbo"

export default class extends Controller {
  static values = {
    title: String,
    message: String,
    confirmText: { type: String },
    cancelText: { type: String },
    size: { type: String, default: "sm" },
    type: { type: String, default: "danger" },
    href: String
  }

  static targets = ["trigger"]

  confirmAndProceed(event) {
    event.preventDefault()

    const title = this.titleValue
    const message = this.messageValue
    const confirmText = this.confirmTextValue
    const cancelText = this.cancelTextValue || window.I18n.modal.danger.cancel_text
    const size = this.sizeValue

    Modal.danger({
      title,
      message,
      confirmText,
      cancelText,
      size,
      onConfirm: () => {
        // For DELETE requests, use the original element href
        // For GET requests, use the hrefValue from the controller
        const href = this.element.getAttribute('href')
        const turboMethod = this.element.dataset.turboMethod
        
        if (turboMethod && (turboMethod.toLowerCase() === 'delete' || turboMethod.toLowerCase() === 'post')) {
          // For DELETE/POST requests, create a form submission using original href
          const form = document.createElement('form')
          form.method = 'POST'
          form.action = href
          
          if (turboMethod.toLowerCase() === 'delete') {
            const methodInput = document.createElement('input')
            methodInput.type = 'hidden'
            methodInput.name = '_method'
            methodInput.value = 'DELETE'
            form.appendChild(methodInput)
          }
          
          // Add CSRF token
          const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
          if (csrfToken) {
            const csrfInput = document.createElement('input')
            csrfInput.type = 'hidden'
            csrfInput.name = 'authenticity_token'
            csrfInput.value = csrfToken
            form.appendChild(csrfInput)
          }
          
          document.body.appendChild(form)
          form.submit()
          document.body.removeChild(form)
        } else if (this.hrefValue) {
          visit(this.hrefValue)
        }
      },
      onCancel: () => {
        this.onCancel(event)
      }
    })
  }

  onCancel(event) {
    this.element.dispatchEvent(new CustomEvent('cancelled', { 
      detail: { originalEvent: event },
      bubbles: true 
    }))
  }

  delete(event) {
    this.titleValue = this.titleValue || window.I18n.modal.danger.title
    this.messageValue = this.messageValue || window.I18n.modal.delete.message;
    this.confirmTextValue = this.confirmTextValue || window.I18n.modal.delete.confirm_text;
    this.confirmAndProceed(event)
  }
} 